import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import AppShell from './components/AppShell'
const Dashboard=lazy(()=>import('./pages/Dashboard'))
const Calls=lazy(()=>import('./pages/Calls'))
const CallDetail=lazy(()=>import('./pages/CallDetail'))
const Directory=lazy(()=>import('./pages/Directory'))
const RoutingPage=lazy(()=>import('./pages/RoutingPage'))
const ResourcePage=lazy(()=>import('./pages/ResourcePage'))

export default function App(){return <AppShell><Suspense fallback={<div className="route-loading">Loading workspace…</div>}><Routes>
  <Route path="/" element={<Dashboard/>}/>
  <Route path="/calls" element={<Calls/>}/>
  <Route path="/calls/:callId" element={<CallDetail/>}/>
  <Route path="/directory" element={<Directory/>}/>
  <Route path="/routing" element={<RoutingPage/>}/>
  <Route path="/pbx-sites" element={<ResourcePage kind="pbx"/>}/>
  <Route path="/ai-models" element={<ResourcePage kind="models"/>}/>
  <Route path="/usage" element={<ResourcePage kind="usage"/>}/>
  <Route path="/alerts" element={<ResourcePage kind="alerts"/>}/>
  <Route path="/access" element={<ResourcePage kind="access"/>}/>
</Routes></Suspense></AppShell>}
